import { moderationItemSchema } from "../schemas/moderation";
import { fetchApi, fetchVoid, paginatedSchema } from "./internal";

export const moderation = {
	listGames: (page = 1) =>
		fetchApi(`/admin/moderation/games?page=${page}`, paginatedSchema(moderationItemSchema)),
	listClubs: (page = 1) =>
		fetchApi(`/admin/moderation/clubs?page=${page}`, paginatedSchema(moderationItemSchema)),
	approveGame: (id: string) =>
		fetchVoid(`/admin/moderation/games/${id}`, {
			method: "PATCH",
			body: JSON.stringify({ status: "approved" }),
		}),
	rejectGame: (id: string) =>
		fetchVoid(`/admin/moderation/games/${id}`, {
			method: "PATCH",
			body: JSON.stringify({ status: "rejected" }),
		}),
	approveClub: (id: string) =>
		fetchVoid(`/admin/moderation/clubs/${id}`, {
			method: "PATCH",
			body: JSON.stringify({ status: "approved" }),
		}),
	rejectClub: (id: string) =>
		fetchVoid(`/admin/moderation/clubs/${id}`, {
			method: "PATCH",
			body: JSON.stringify({ status: "rejected" }),
		}),
};
